export const ApplicationSource = Object.freeze({ Internal: 1, External: 2 });
